// Color schemes for the application

const colorSchemes = {
  // Original vibrant color scheme (current)
  vibrant: {
    beige: "#ffba8d",
    seafoamgreen: "#89d389",
    green: "#4ab84f",
    greenborder: "#5de863",
    wahooblue: "#003479",
    yellow: "#ffd04c",
    yellowborder: "#ffea9a",
    salmonpink: "#ffa6b4",
    salmonpinkborder: "#ffc4ce",
    tacxblue: "#52bdec",
    tacxbluemuted: "#5ca9e3",
    tacxblueborder: "#7ac2ec",
    magenta: "#ff40c5",
    sonicblue: "#84d0e6",
    sonicblueborder: "#99ebf7",
    orange: "#fc6719",
    orangeborder: "#f28f20",
    steel: "#4682b4",
    fiestared: "#fa5d53",
    fiestaredborder: "#f76b4e",
    lavender: "#bb89ec",
    slategray: "#3e3e3e",
    brand: "#178acc",
    brandinverse: "#e68200",
    purple: "#b535ce",
    lightblue: "#42e6ff"
  },

  // Muted, professional color scheme inspired by intervals.icu
  muted: {
    beige: "#d4b896",
    seafoamgreen: "#7ba87b",
    green: "#6b926b",
    greenborder: "#8aa88a",
    wahooblue: "#4a5f7a",
    yellow: "#c9b366",
    yellowborder: "#d6c48a",
    salmonpink: "#b8949a",
    salmonpinkborder: "#c7a5ab",
    tacxblue: "#7a9db8",
    tacxbluemuted: "#8aa3b8",
    tacxblueborder: "#9bb1c4",
    magenta: "#a67ea6",
    sonicblue: "#8fb5c4",
    sonicblueborder: "#a3c4d0",
    orange: "#b8845a",
    orangeborder: "#c4966b",
    steel: "#6b8aa6",
    fiestared: "#b8756e",
    fiestaredborder: "#c4887c",
    lavender: "#9d89b8",
    slategray: "#5a5a5a",
    brand: "#6b92b8",
    brandinverse: "#b8926b",
    purple: "#8a6b9d",
    lightblue: "#7ab8c9"
  },

  // Monochromatic scheme for ultra-minimal look
  monochrome: {
    beige: "#b8b8b8",
    seafoamgreen: "#9a9a9a",
    green: "#8a8a8a",
    greenborder: "#a8a8a8",
    wahooblue: "#7a7a7a",
    yellow: "#b8b8b8",
    yellowborder: "#c4c4c4",
    salmonpink: "#a8a8a8",
    salmonpinkborder: "#b8b8b8",
    tacxblue: "#9a9a9a",
    tacxbluemuted: "#a8a8a8",
    tacxblueborder: "#b8b8b8",
    magenta: "#8a8a8a",
    sonicblue: "#a8a8a8",
    sonicblueborder: "#b8b8b8",
    orange: "#9a9a9a",
    orangeborder: "#a8a8a8",
    steel: "#8a8a8a",
    fiestared: "#a8a8a8",
    fiestaredborder: "#b8b8b8",
    lavender: "#9a9a9a",
    slategray: "#6a6a6a",
    brand: "#8a8a8a",
    brandinverse: "#a8a8a8",
    purple: "#9a9a9a",
    lightblue: "#a8a8a8"
  }
};

// Current active color scheme - change this to switch schemes
export const ACTIVE_COLOR_SCHEME = "vibrant"; // Options: 'vibrant', 'muted', 'monochrome'

// Get the active color scheme
export const getActiveColors = () => {
  return colorSchemes[ACTIVE_COLOR_SCHEME] || colorSchemes.vibrant;
};

// Export all schemes for potential future use (settings panel, etc.)
export {colorSchemes};

// Export active colors as default export for backward compatibility
export default getActiveColors();
